import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcGrupo,
    EnumIdsTcTipoPuntoInspeccion,
    EnumIdsTcTipoSolicitud,
    EnumIdsTwTcTipoClonacion,
} from '../types/enum';
import { ProductosService } from './productos.service';
import {
    EquipamientoViewModel,
    SolicitudProductosViewModel,
    TProductoSolicitudViewModel,
    TwEmbalajesViewModel,
    COOKIE_CONFIG_INCOMPATIBLE_NAME,
} from './productos.types';
import { HttpParams } from '@angular/common/http';
import { CookiesService } from '../../../core/_infrastructure/classes/services/cookies.service';
import { SolicitudViewModel } from '../datosbasicos/datosbasicos.types';
import { tap, catchError, of } from 'rxjs';

@Component({
    selector: 'app-productos-list',
    templateUrl: './productos-list.component.html',
})
export class ProductosSolicitudListComponent extends ComponentBase implements OnInit {
    solicitudProductos: SolicitudProductosViewModel;
    habilitarGuardar = true;
    habilitarNuevoProducto = true;
    habilitarNuevoEmbalaje = true;
    habilitarNuevaMatricula = true;
    productoFitosanitarioFound = false;

    numeroBultosTotales = 0;
    private EsInspector: boolean;
    private EsGrabador: boolean;
    EsPuerto = false;
    productoEditable: boolean;
    productoBorrable: boolean;
    matriculaBorrable: boolean;
    IdTipoSolicitud: number;

    isCollapsedEquipamiento = false;
    isCollapsedEmbalaje = false;
    visibilityEmbalajes = false;
    visibilitySpinner = false;
    tituloTipoSolicitud: string;
    private laHeGrabadoYo = false;
    esClonada = false;
    esRechazoParcial = false;
    isCanariasPifCanarias = false;
    colsProds: any[];
    colsEmbalajes: any[];
    private matriculaLengthError = 'La longitud de cada matrícula no puede superar los 50 caracteres';
    messageProductoFitosanitarioLimit =
        'Las solicitudes con productos del grupo "Productos Fitosanitarios", están limitadas a un único producto o partida para ir por la vía del "No Procede" en la Decisión';
    idSolicitud: number;
    configuracionesIncompatibles = false;
    solicitud: SolicitudViewModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        private confirmationService: ConfirmationService,
        protected exceptionHandler: ExceptionManager,
        private solicitudService: SolicitudService,
        private productosService: ProductosService,
        private cookiesService: CookiesService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudProductos = new SolicitudProductosViewModel();
        this.solicitud = new SolicitudViewModel();
    }

    ngOnInit() {
        this.idSolicitud = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitud);
        this.createForm();

        this.EsInspector = this.isInspector;
        this.EsGrabador = this.isGrabador;

        if (this.idSolicitud) {
            this.loadSolicitudUsuarioById();
        }

        // Contenedores, abrimos solo el primero
        this.isCollapsedEquipamiento = false;
        this.isCollapsedEmbalaje = false;
        this.createColsForTables();

        const cookieValue_encoded = this.cookiesService.getCookie(COOKIE_CONFIG_INCOMPATIBLE_NAME);

        if (cookieValue_encoded) {
            // Relacionado con error Kiuwan (Improper neutralization of CR/LF Sequences in HTTP headers)
            const cookieValue = this.cookiesService.getOriginalValueFromHeader(cookieValue_encoded);
            if (cookieValue === null) {
                this.addErrorMessage('Error parsing IDSolicitudConfigIncompatible cookie JSON');
                return;
            }
            const decodedCookie = decodeURIComponent(cookieValue);

            // Parsea la cookie a array de números
            let incompatiblesIds: number[] = [];

            try {
                incompatiblesIds = JSON.parse(decodedCookie);
            } catch (e) {
                this.addErrorMessage('Error parsing IDSolicitudConfigIncompatible cookie JSON');
                return;
            }

            // Convierte el idSolicitud a número
            const currentId = this.idSolicitud;

            // Verifica si el currentId está en la lista
            if (incompatiblesIds.includes(currentId)) {
                this.configuracionesIncompatibles = true;

                // Remueve el currentId de la lista
                incompatiblesIds = incompatiblesIds.filter(id => id !== currentId);

                if (incompatiblesIds.length > 0) {
                    const incompatiblesJson = JSON.stringify(incompatiblesIds);
                    // Guarda la cookie con 1 día de expiración (por ejemplo)
                    // Relacionado con error Kiuwan (Improper neutralization of CR/LF Sequences in HTTP headers)
                    const incompatiblesJson_headerSafe = this.cookiesService.getHeaderSafeValue(incompatiblesJson);
                    this.cookiesService.setCookie(COOKIE_CONFIG_INCOMPATIBLE_NAME, incompatiblesJson_headerSafe, 1);
                } else {
                    // Si no queda ninguno, elimina la cookie
                    this.cookiesService.deleteCookie(COOKIE_CONFIG_INCOMPATIBLE_NAME);
                }
            }
        }
    }

    private createColsForTables(): void {
        // Cambios Productos
        this.colsProds = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'CodigoTaric', header: 'Cód. Taric' },
            { field: 'IdPaisDescripcion', header: 'País Origen' },
            { field: 'IdBotanicaDescripcion', header: 'Nom Científico' },
            { field: 'CodigoEppo', header: 'Cód. EPPO' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'Grupo', header: 'Grupo' },
            { field: 'IdFormaDescripcion', header: 'Forma' },
            { field: 'Peso', header: 'Peso (Kg)' },
            { field: 'Unidades', header: 'Unidades (Ud)' },
            { field: 'Volumen', header: 'Volumen (m³)' },
            { field: 'NumeroBulto', header: 'Bultos' },
            //{ field: 'EsOrganico', header: 'Orgánico' }, //RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
        ];

        //Cambios Embalajes
        this.colsEmbalajes = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdTaricEmbalajeDescripcion', header: 'Material de Embalaje' },
            { field: 'IdEppoEmbalajeDescripcion', header: 'Cód. EPPO' },
            { field: 'Recuento', header: 'Recuento' },
            { field: 'IdUnidadEmbalajeDescripcion', header: 'Unidad' },
            { field: 'IdPaisEmbalajeDescripcion', header: 'País Origen' },
        ];
    }

    private loadSolicitudUsuarioById(): void {
        // Para saber si se actua como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitud', this.idSolicitud.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());
        this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;
            this.loadSolicitudProductosById();
        });
    }

    /**
     * Este método se invoca al cargar el componente y una vez se ha obtenido información sobre si el usuario ha grabado o no la solicitud.
     * Se obtiene la siguiente información:
     * - Lista de productos de la solicitud
     * - S comprueba si la solicitud es clonada.
     * - Se rellena el título indicando si la solicitud es:
     *   - re-importación
     *   - previa
     * - Se obtienen los permisos en función de si el usuario es grabador y/o inspector
     * - Se obtiene el número de productos y embajales.
     * - Si es puerto, se marca el campo matrícula como obligatorio.
     */
    private loadSolicitudProductosById(): void {
        this.productosService.getSolicitudProductos(this.idSolicitud).subscribe(result => {
            this.solicitudProductos = result;
            this.IdTipoSolicitud = this.solicitudProductos.IdTipoSolicitud;
            this.tituloTipoSolicitud = this.solicitudProductos.IdTipoSolicitudDescripcion;
            this.isCanariasPifCanarias = this.solicitudProductos.IsCanariasPifCanarias;
            this.esClonada =
                this.solicitudProductos.TwSolicitudJerarquia != null &&
                this.solicitudProductos.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            this.esRechazoParcial = this.solicitudProductos.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE;
            // SI ES RECHAZO PARCIAL SOLO SE LISTAN LOS PRODUCTOS CON LA VARIABLE "DeRechazoParcial" A TRUE
            if (this.esRechazoParcial) {
                this.solicitudProductos.TProductoSolicitudCollection = this.solicitudProductos.TProductoSolicitudCollection.filter(
                    p => p.DeRechazoParcial === true,
                );
            }
            // SI ES RE-IMPORTACION
            if (this.solicitudProductos.EsReImportacion) {
                this.tituloTipoSolicitud += ' - Re-Importación';
            }
            // SI ES PREVIA
            if (this.solicitudProductos.EsPrevia) {
                if (
                    this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                    this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitud += ' - Previa';
                }
            }

            //SI ES CANARIAS PIF CANARIAS (y NO es Predua) se muestra también la Declaracion Sumaria
            if (this.isCanariasPifCanarias && !this.solicitudProductos.EsPredua) {
                this.colsProds.push({ field: 'DeclaracionSumaria', header: 'Nº Declaración Sumaria' });
            }

            this.manageActionsForButtons();

            this.calculoNumeroBultos();

            //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD, this.solicitudProductos.IdEstadoSolicitud).Visible;
            this.EsPuerto = this.solicitudProductos?.TPuntoInspeccion?.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_PUERTO;
            // @comment: La validación de la obligatoriedad del campo matrícula, por ser PIF puerto, se realiza en el backend.

            if (this.productoFitosanitarioInList()) {
                this.productoFitosanitarioFound = true;
                this.habilitarNuevoProducto = false;
            }
            //metodo para deshabilitar los controles
            this.disableControlsConsulta();

            this.updateForm();
        });
    }

    private manageActionsForButtons(): void {
        // Si soy Grabador
        if (this.EsGrabador && this.solicitudProductos.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
            this.habilitarGuardar =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.solicitudProductos.IdEstadoSolicitud).Visible &&
                this.laHeGrabadoYo;
            /*|| (this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_INSPECCION, this.solicitudProductos.IdEstadoSolicitud).Visible)*/
            this.habilitarNuevoProducto =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.solicitudProductos.IdEstadoSolicitud).Visible &&
                this.laHeGrabadoYo;

            this.habilitarNuevoEmbalaje = this.habilitarNuevoProducto;
            this.habilitarNuevaMatricula = this.habilitarNuevoProducto;
        } else {
            this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.solicitudProductos.IdEstadoSolicitud).Visible;
            /*|| (this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_INSPECCION, this.solicitudProductos.IdEstadoSolicitud).Visible)*/
            this.habilitarNuevoProducto = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                this.solicitudProductos.IdEstadoSolicitud,
            ).Visible;

            this.habilitarNuevoEmbalaje = this.habilitarNuevoProducto;
            this.habilitarNuevaMatricula = this.habilitarNuevoProducto;
        }

        this.productoEditable = this.checkEdit();
        this.productoBorrable = this.checkDelete();
        this.matriculaBorrable = this.checkDeleteMatricula();
    }

    private checkEdit() {
        //Si soy Grabador
        if (this.EsGrabador && this.solicitudProductos.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
            return (
                this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                    this.solicitudProductos.IdEstadoSolicitud,
                    undefined,
                    this.solicitudProductos.IdSubTipoSolicitud!,
                ).Visible && this.laHeGrabadoYo
            );
        } else {
            return this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                this.solicitudProductos.IdEstadoSolicitud,
                undefined,
                this.solicitudProductos.IdSubTipoSolicitud!,
            ).Visible;
        }
    }

    private checkDelete() {
        //Si soy Grabador
        if (this.EsGrabador && this.solicitudProductos.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
            return (
                this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                    this.solicitudProductos.IdEstadoSolicitud,
                    undefined,
                    this.solicitudProductos.IdSubTipoSolicitud!,
                ).Visible && this.laHeGrabadoYo
            );
        } else {
            return this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                this.solicitudProductos.IdEstadoSolicitud,
                undefined,
                this.solicitudProductos.IdSubTipoSolicitud!,
            ).Visible;
        }
    }

    private checkDeleteMatricula() {
        //Si soy Grabador
        if (this.EsGrabador && this.solicitudProductos.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
            return (
                this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                    this.solicitudProductos.IdEstadoSolicitud,
                    undefined,
                    this.solicitudProductos.IdSubTipoSolicitud!,
                ).Visible && this.laHeGrabadoYo
            );
        } else {
            return this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                this.solicitudProductos.IdEstadoSolicitud,
                undefined,
                this.solicitudProductos.IdSubTipoSolicitud!,
            ).Visible;
        }
    }

    private guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    private createForm() {
        this.form = this.fb.group({
            Matricula: '',
            //Observaciones: '',
            //IdNimf15: null
            //IdTipoEmbalaje: 0,
            //IdCodigoEppo: 0,
            //IdCodigoTaric: 0,
            //NumeroPaquetes: '',
        });
    }

    private updateForm() {
        this.form.setValue({
            Matricula: '',
            //IdNimf15: this.solicitudProductos.IdNimf15 == null ? ''
            //    : this.solicitudProductos.IdNimf15 == EnumIdsTcNimf15.ID_CUMPLE ? '1'
            //        : this.solicitudProductos.IdNimf15 == EnumIdsTcNimf15.ID_NO_CUMPLE ? '2'
            //            : '3',
            //Observaciones: this.solicitudProductos.Observaciones
        });
    }

    /**
     * Este método calcula el número total del bultos a partir del recuento de los embalajes.
     */
    private calculoNumeroBultos() {
        this.numeroBultosTotales = 0;
        this.solicitudProductos?.TwEmbalajesCollection.forEach(y => {
            this.numeroBultosTotales += y?.Recuento;
        });
    }

    private disableControlsConsulta() {
        if (
            this.EsInspector &&
            !this.laHeGrabadoYo &&
            this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_BORRADOR &&
            this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE
        ) {
            this.form.controls['Matricula'].disable();
            this.visibilityEmbalajes = true;
            //if (!this.habilitarGuardar) {
            //this.form.controls['IdNimf15'].disable();
            //this.form.controls['Observaciones'].disable();
            //}
        } else {
            //this.form.controls['IdNimf15'].disable();
            //this.form.controls['Observaciones'].disable();

            if (!this.habilitarNuevaMatricula) {
                this.form.controls['Matricula'].disable();
            }
            //visibilidad Embalajes para solicitante, solo si debe ver alguna información
            //if (!(this.solicitudProductos.IdNimf15 == null && this.solicitudProductos.Observaciones == null)) {
            //    this.visibilityEmbalajes = true;
            //}
        }
    }

    /**
     * Se validará (al guardar) que si la solicitud es de tipo predua y tiene más de un producto,
     * solo permita añadir uno de tipo fitosanitario.
     * Además, en éste caso la lista de productos solo podrá tener un producto.
     * @returns boolean
     */
    private productoFitosanitarioInList(): boolean {
        if (this.solicitudProductos.IdTipoSolicitud === EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS) {
            const productoFitosanitarioFound = this.solicitudProductos?.TProductoSolicitudCollection?.find(
                elem => elem.IdGrupo === EnumIdsTcGrupo.ID_PRODUCTOS_FITOSANITARIOS,
            );
            return productoFitosanitarioFound !== null && productoFitosanitarioFound !== undefined;
        } else {
            return false;
        }
    }

    onAddProducto() {
        this.router.navigate(['/importacion/solicitud/productos/', this.solicitudProductos.Id, 'create']);
    }

    onEditProducto(item: SolicitudProductosViewModel) {
        this.router.navigate(['/importacion/solicitud/productos', this.solicitudProductos.Id, 'producto', item.Id]);
    }

    onDeleteProducto(item: TProductoSolicitudViewModel) {
        this.solicitudService
            .getSolicitud(this.solicitudProductos.Id)
            .pipe(
                tap((result: SolicitudViewModel) => {
                    this.solicitud = result;

                    if (
                        this.solicitudProductos.TProductoSolicitudCollection.length === 1 &&
                        this.solicitud.TImportador?.Nif != null &&
                        this.solicitud.TImportador?.Nif != '' &&
                        this.solicitud.TImportador?.Nif != undefined
                    ) {
                        this.confirmationService.confirm({
                            message: '¿Está seguro? Si ha introducido datos en la sección "Importador | Lugar Destino" estos serán eliminados también',
                            accept: () => {
                                // Actual logic to perform a confirmation
                                this.productosService.deleteSolicitudProductos(item.Id).subscribe(() => {
                                    this.addSuccessMessage('Producto eliminado correctamente');
                                    this.ngOnInit();
                                });
                            },
                        });
                    } else {
                        this.confirmationService.confirm({
                            message: '¿Está seguro?',
                            accept: () => {
                                // Actual logic to perform a confirmation
                                this.productosService.deleteSolicitudProductos(item.Id).subscribe(() => {
                                    this.addSuccessMessage('Producto eliminado correctamente');
                                    this.ngOnInit();
                                });
                            },
                        });
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of([]);
                }),
            )
            .subscribe();
    }

    onAddEmbalaje() {
        this.router.navigate(['/importacion/solicitud/productos/', this.solicitudProductos.Id, 'create_packing']);
    }

    onEditEmbalaje(item: TwEmbalajesViewModel) {
        this.router.navigate(['/importacion/solicitud/productos', this.solicitudProductos.Id, 'embalaje', item.Id]);
    }

    onDeleteEmbalaje(item: TwEmbalajesViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.productosService.deleteEmbalaje(item.Id).subscribe(() => {
                    this.addSuccessMessage('Embalaje eliminado correctamente');
                    this.ngOnInit();
                });
            },
        });
    }

    onAddMatricula() {
        //se podrán insertar varias separadas por comas (,)
        let matriculas = this.form.value.Matricula;
        let arrayMatriculas: string[] = matriculas.split(',');

        arrayMatriculas.forEach(x => {
            if (x != '') {
                let equipamiento = new EquipamientoViewModel();
                const matricula = x.trim();
                if (matricula?.length > 50) {
                    this.addErrorMessage(this.matriculaLengthError + ' : ' + matricula);
                    return;
                }
                equipamiento.Matricula = matricula;
                this.solicitudProductos.TSolicitudEquipamientoCollection.push(equipamiento);
            }
        });

        this.form.patchValue({
            Matricula: '',
        });
    }

    onDeleteMatricula(item: EquipamientoViewModel) {
        this.solicitudProductos.TSolicitudEquipamientoCollection.splice(this.solicitudProductos.TSolicitudEquipamientoCollection.indexOf(item), 1);
    }

    onGuardarMatriculas() {
        //if (this.EsInspector && !this.laHeGrabadoYo && this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_BORRADOR
        //    && this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
        //    this.confirmationService.confirm({
        //        message: '¿Está seguro de guardar el embalaje de la solicitud?',
        //        accept: () => {
        //            this.onSubmit();
        //        }
        //    });
        //}
        //else {
        this.confirmationService.confirm({
            message: '¿Está seguro de guardar las matrículas de la solicitud?',
            accept: () => {
                this.onSubmit();
            },
        });
        //}
    }

    onSubmit() {
        this.submitted = true;
        let numRepeticiones = 0;
        let errorMatriculas = false;

        if (
            !(
                this.EsInspector &&
                !this.laHeGrabadoYo &&
                this.solicitudProductos?.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_BORRADOR &&
                this.solicitudProductos?.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE
            )
        ) {
            //comprobar que no hay matriculas repetidas
            this.solicitudProductos?.TSolicitudEquipamientoCollection.forEach(x => {
                numRepeticiones = this.solicitudProductos?.TSolicitudEquipamientoCollection.filter(s => s.Matricula == x.Matricula).length;
                if (numRepeticiones > 1) {
                    errorMatriculas = true;
                }
            });

            if (errorMatriculas) {
                this.addErrorMessage('Hay matrículas repetidas en la lista de equipamientos');
                return;
            }
        }

        if (!this.form.valid) {
            return;
        }

        const solicitudProductos = this.createSolicitudProductos();
        this.saveSolicitudProductos(solicitudProductos);
    }

    private createSolicitudProductos(): SolicitudProductosViewModel {
        const solicitudProductos = new SolicitudProductosViewModel();
        solicitudProductos.TSolicitudEquipamientoCollection = this.solicitudProductos?.TSolicitudEquipamientoCollection;
        solicitudProductos.Id = this.solicitudProductos?.Id;

        //Si es Inspector guarda el EMBALAJE
        //if (this.EsInspector && !this.laHeGrabadoYo && this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_BORRADOR
        //    && this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {

        //let embalaje = new TwEmbalajesViewModel();
        //embalaje.IdSolicitud = this.solicitudProductos.Id;
        //embalaje.IdNimf15 = this.form.value.IdNimf15 == '1' ? EnumIdsTcNimf15.ID_CUMPLE
        //    : this.form.value.IdNimf15 == '2' ? EnumIdsTcNimf15.ID_NO_CUMPLE
        //        : this.form.value.IdNimf15 == '3' ? EnumIdsTcNimf15.ID_NO_APLICA
        //            : null;
        //embalaje.Observaciones = this.form.value.Observaciones;
        //embalaje.IdInspector = this.loggedInUser!.Id;
        //solicitudProductos.TwEmbalajes = embalaje;
        //}

        return solicitudProductos;
    }

    private saveSolicitudProductos(solicitudProductos: SolicitudProductosViewModel): void {
        if (
            !(
                this.EsInspector &&
                !this.laHeGrabadoYo &&
                this.solicitudProductos?.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_BORRADOR &&
                this.solicitudProductos?.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE
            )
        ) {
            this.visibilitySpinner = true;
            this.productosService.editSolicitudProductos(solicitudProductos).subscribe({
                next: () => {
                    this.addSuccessMessage('Matrículas guardadas correctamente');
                    this.visibilitySpinner = false;
                    this.router.navigate(['/importacion/solicitud/productos/' + this.solicitudProductos?.Id]);
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
        //else {
        //    this.visibilitySpinner = true;
        //    this.productosService.editEmbalajeSolicitudProductos(solicitudProductos)
        //        .subscribe(res => {
        //            this.addSuccessMessage("Embalaje guardado correctamente");
        //            this.router.navigate(["/importacion/solicitud/productos/" + this.solicitudProductos.Id]);
        //            //this.onBack();
        //            this.visibilitySpinner = false;
        //        }, error => {
        //            this.catchServerError(error);
        //            this.visibilitySpinner = false;
        //        }
        //        );
        //}
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.solicitudProductos.Id]);
    }
}
